var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.048 13.869A12.634 12.634 0 017.41 10.06a.749.749 0 01.166-.827l.819-.819a1.53 1.53 0 00.085-2.206L7.306 5.035a2 2 0 00-2.828 0l-.652.651a3.194 3.194 0 00-.85 2.87 15.715 15.715 0 004.461 7.923 15.715 15.715 0 007.923 4.461 3.194 3.194 0 002.87-.85l.651-.651a2 2 0 000-2.828l-1.173-1.173a1.5 1.5 0 00-2.121 0l-.9.9a.749.749 0 01-.827.166 12.674 12.674 0 01-3.812-2.635z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M12.92 5.17V2.83M17.09 6.82l1.65-1.64M18.75 11h2.33"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default SvgPhoneCall;


//////////////////
// WEBPACK FOOTER
// ./src/icons/phoneCall.svg
// module id = 321
// module chunks = 11